import { gcApi } from 'config/axios';
import { takeEvery, call, put, select, takeLatest, fork } from 'redux-saga/effects';

import {
    // activities
    FETCH_NEWS_FEED_ACTIVITIES,
    FETCH_NEWS_FEED_ACTIVITIES_START,
    FETCH_NEWS_FEED_ACTIVITIES_SUCCESS,
    FETCH_NEWS_FEED_ACTIVITIES_FAIL,
    UPDATE_NEWS_FEED_ACTIVITY_COMMENT_COUNT,
    UPDATE_NEWS_FEED_ACTIVITY_PRIVACY,
    UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_START,
    UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_SUCCESS,
    UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_FAIL,
    UPDATE_NEWS_FEED_ERROR_STATE,
    FILTER_NEWS_FEED_ACTIVITIES,
    FETCH_NEWS_FEED_ACTIVITY_AND_UPDATE_LIKES,
    UPDATE_NEWS_FEED_ACTIVITY_LIKES,
    // comments
    FETCH_NEWS_FEED_COMMENTS,
    FETCH_NEWS_FEED_COMMENTS_START,
    FETCH_NEWS_FEED_COMMENTS_SUCCESS,
    FETCH_NEWS_FEED_COMMENTS_FAIL,
    ADD_NEWS_FEED_COMMENT,
    ADD_NEWS_FEED_COMMENT_START,
    ADD_NEWS_FEED_COMMENT_SUCCESS,
    ADD_NEWS_FEED_COMMENT_FAIL,
    EDIT_NEWS_FEED_COMMENT,
    EDIT_NEWS_FEED_COMMENT_START,
    EDIT_NEWS_FEED_COMMENT_SUCCESS,
    EDIT_NEWS_FEED_COMMENT_FAIL,
    REMOVE_NEWS_FEED_COMMENT,
    REMOVE_NEWS_FEED_COMMENT_START,
    REMOVE_NEWS_FEED_COMMENT_SUCCESS,
    REMOVE_NEWS_FEED_COMMENT_FAIL,
    UPDATE_NEWS_FEED_COMMENT_LIKED_BY_USER,
    FETCH_NEWS_FEED_COMMENT_LIKERS,
    FETCH_NEWS_FEED_COMMENT_LIKERS_SUCCESS,
    FETCH_NEWS_FEED_COMMENT_LIKERS_FAIL,
    UPDATE_NEWS_FEED_COMMENT_LIKERS,
    ADD_NEWS_FEED_HIGHLIGHTED_COMMENTS,
    // likes
    FETCH_NEWS_FEED_CONVERSATION_LIKES,
    FETCH_NEWS_FEED_CONVERSATION_LIKES_START,
    FETCH_NEWS_FEED_CONVERSATION_LIKES_SUCCESS,
    FETCH_NEWS_FEED_CONVERSATION_LIKES_FAIL,
    FETCH_NEWS_FEED_COMMENT_LIKES,
    FETCH_NEWS_FEED_COMMENT_LIKES_START,
    FETCH_NEWS_FEED_COMMENT_LIKES_SUCCESS,
    FETCH_NEWS_FEED_COMMENT_LIKES_FAIL,
    ADD_NEWS_FEED_COMMENT_LIKE,
    ADD_NEWS_FEED_COMMENT_LIKE_START,
    ADD_NEWS_FEED_COMMENT_LIKE_SUCCESS,
    ADD_NEWS_FEED_COMMENT_LIKE_FAIL,
    REMOVE_NEWS_FEED_COMMENT_LIKE,
    REMOVE_NEWS_FEED_COMMENT_LIKE_START,
    REMOVE_NEWS_FEED_COMMENT_LIKE_SUCCESS,
    REMOVE_NEWS_FEED_COMMENT_LIKE_FAIL,
    ADD_NEWS_FEED_CONVERSATION_LIKE,
    ADD_NEWS_FEED_CONVERSATION_LIKE_START,
    ADD_NEWS_FEED_CONVERSATION_LIKE_SUCCESS,
    ADD_NEWS_FEED_CONVERSATION_LIKE_FAIL,
    REMOVE_NEWS_FEED_CONVERSATION_LIKE,
    REMOVE_NEWS_FEED_CONVERSATION_LIKE_START,
    REMOVE_NEWS_FEED_CONVERSATION_LIKE_SUCCESS,
    REMOVE_NEWS_FEED_CONVERSATION_LIKE_FAIL,
    // connections
    REMOVE_CONNECTION,
    REMOVE_CONNECTION_START,
    REMOVE_CONNECTION_SUCCESS,
    REMOVE_CONNECTION_FAIL,
    MUTE_CONNECTION,
    MUTE_CONNECTION_START,
    MUTE_CONNECTION_SUCCESS,
    MUTE_CONNECTION_FAIL,
    UNMUTE_CONNECTION,
    UNMUTE_CONNECTION_START,
    UNMUTE_CONNECTION_SUCCESS,
    UNMUTE_CONNECTION_FAIL,
    FETCH_MUTED_CONNECTION_LIST,
    FETCH_MUTED_CONNECTION_LIST_START,
    FETCH_MUTED_CONNECTION_LIST_SUCCESS,
    FETCH_MUTED_CONNECTION_LIST_FAIL,
    FETCH_CONNECTION_COUNT,
    FETCH_CONNECTION_COUNT_SUCCESS,
    FETCH_CONNECTION_COUNT_FAIL,
    FETCH_SUGGESTED_CONNECTION_LIST,
    FETCH_SUGGESTED_CONNECTION_LIST_START,
    FETCH_SUGGESTED_CONNECTION_LIST_SUCCESS,
    FETCH_SUGGESTED_CONNECTION_LIST_FAIL,
    FETCH_PAGED_SUGGESTED_CONNECTION_LIST,
    FETCH_PAGED_SUGGESTED_CONNECTION_LIST_START,
    FETCH_PAGED_SUGGESTED_CONNECTION_LIST_SUCCESS,
    FETCH_PAGED_SUGGESTED_CONNECTION_LIST_FAIL,
    FETCH_SUGGESTED_CONNECTIONS_COUNT,
    FETCH_SUGGESTED_CONNECTIONS_COUNT_SUCCESS,
    FETCH_SUGGESTED_CONNECTIONS_COUNT_FAIL,
    // reporter
    NEWS_FEED_SUMBIT_REPORT_PHOTO
} from 'actions/ActionTypes';

// actions
import {
    setNewsfeedErrorState,
    resetNewsfeedErrorState,
    submitReportPhotoDone,
    removePhotoFromFeed
} from 'actions/newsFeedActions';
import { setSocialLimitErrorDialog } from 'actions/socialActions';
import {
    fetchMultipleUserSocialProfileImage,
    fetchMultipleUserSocialProfileImageDone
} from 'actions/userSocialProfileImageActions';

// Utils
import { pushNewsFeedAnalytics } from 'utils/newsFeed/newsFeedUtil';
// utils -- userSocialProfileImage
import { PROFILE_IMAGE_VERSION } from 'utils/userSocialProfileImage/profileImageConstantsV2';

import { getReportDialogState } from 'reducers/newsFeed/newsFeedActivities';
import { hideModal } from 'actions';
import { forceCheckHasUserProfileFrameFeature } from './userSocialProfileImageSagas';
import { toQueryString } from 'utils/UrlUtil';

export function* fetchNewsFeedComments(action) {
    const { activityId } = action.payload;
    try {
        const PAGE_SIZE = 10;
        const comments = yield select((state) => state.newsFeedComments.comments[activityId] || []);
        const start = comments.length + 1;

        yield put({
            type: FETCH_NEWS_FEED_COMMENTS_START,
            activityId
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        const response = yield call(
            gcApi.get,
            `/conversation-service/conversation/comments/ACTIVITY/${activityId}?start=${start}&limit=${PAGE_SIZE}`
        );

        yield put({
            type: FETCH_NEWS_FEED_COMMENTS_SUCCESS,
            data: response.data,
            activityId
        });

        yield fork(fetchCommentsProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_NEWS_FEED_COMMENTS_FAIL,
            activityId
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* addNewsFeedComment(action) {
    const { data, activityId } = action.payload;
    try {
        yield put({
            type: ADD_NEWS_FEED_COMMENT_START,
            activityId
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        const response = yield call(
            gcApi.post,
            `/conversation-service/conversation/comment/ACTIVITY/${activityId}/null`,
            data
        );

        yield put({
            type: UPDATE_NEWS_FEED_ACTIVITY_COMMENT_COUNT,
            payload: { addCount: true, activityId }
        });

        yield put({
            type: ADD_NEWS_FEED_COMMENT_SUCCESS,
            data: response.data,
            activityId
        });
    } catch (e) {
        const errorReachLimit = e.response && e.response.status === 429;

        if (errorReachLimit) {
            yield put(setSocialLimitErrorDialog({ open: true, errorType: 'comment' }));
        }
        yield put({
            type: ADD_NEWS_FEED_COMMENT_FAIL,
            activityId,
            errorReachLimit
        });

        if (!errorReachLimit) {
            // set news feed error state
            yield put({
                type: UPDATE_NEWS_FEED_ERROR_STATE,
                hasError: true
            });
        }
    }
}

export function* editNewsFeedComment(action) {
    const { data, activityId, conversationUuid, conversationCommentUuid } = action.payload;
    try {
        yield put({
            type: EDIT_NEWS_FEED_COMMENT_START,
            conversationCommentUuid
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        const response = yield call(
            gcApi.put,
            `/conversation-service/conversation/comment/${conversationUuid}/${conversationCommentUuid}`,
            data
        );

        yield put({
            type: EDIT_NEWS_FEED_COMMENT_SUCCESS,
            data: response.data,
            activityId: activityId,
            conversationCommentUuid: conversationCommentUuid
        });
    } catch (e) {
        yield put({
            type: EDIT_NEWS_FEED_COMMENT_FAIL,
            conversationCommentUuid: conversationCommentUuid
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* removeNewsFeedComment(action) {
    try {
        yield put({
            type: REMOVE_NEWS_FEED_COMMENT_START
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        const { conversationUuid, conversationCommentUuid, conversationCommentPk, activityId } = action.payload;
        yield call(
            gcApi.delete,
            `/conversation-service/conversation/comment/${conversationUuid}/${conversationCommentUuid}/${conversationCommentPk}`
        );

        yield put({
            type: UPDATE_NEWS_FEED_ACTIVITY_COMMENT_COUNT,
            payload: { addCount: false, activityId }
        });

        yield put({
            type: REMOVE_NEWS_FEED_COMMENT_SUCCESS,
            activityId,
            conversationCommentUuid
        });
    } catch (e) {
        yield put({
            type: REMOVE_NEWS_FEED_COMMENT_FAIL
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* fetchNewsFeedCommentLikes(action) {
    const {
        conversationCommentUuid,
        activityId,
        start,
        limit,
        connectionStatusIncluded,
        resourceType
    } = action.payload;
    try {
        const isVivokidChallenge =
            resourceType === 'VIVOKID_ADHOC_CHALLENGE' || resourceType === 'VIVOKID_TEAM_CHALLENGE';

        yield put({
            type: FETCH_NEWS_FEED_COMMENT_LIKES_START,
            reset: start === 1
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        let url;
        if (isVivokidChallenge) {
            url = `/vivokidchallenge-service/conversation/comment/likes/${conversationCommentUuid}?start=${start}&limit=${limit}`;
        } else {
            url = `/conversation-service/conversation/comment/likes/v2/${conversationCommentUuid}?start=${start}&limit=${limit}&connectionStatusIncluded=${connectionStatusIncluded}`;
        }

        const response = yield call(gcApi.get, url);

        let data;
        if (isVivokidChallenge) {
            data = response.data;
        } else {
            const { commentLikeList, numberOfLikes } = response.data;
            data = commentLikeList;
            // if we have valid activityId, we're gonna update the liker info for that activity to newsFeedComments reducer
            if (activityId) {
                yield put({
                    type: UPDATE_NEWS_FEED_COMMENT_LIKERS,
                    activityId,
                    commentUuid: conversationCommentUuid,
                    likers: commentLikeList.map((liker) => ({
                        fullName: liker.fullName,
                        displayName: liker.displayName
                    })),
                    numberOfLikes
                });
            }
        }

        yield put({
            type: FETCH_NEWS_FEED_COMMENT_LIKES_SUCCESS,
            data: data || []
        });
    } catch (e) {
        yield put({
            type: FETCH_NEWS_FEED_COMMENT_LIKES_FAIL
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* addNewsFeedCommentLike(action) {
    try {
        const { conversationCommentUuid, activityId } = action.payload;
        yield put({
            type: ADD_NEWS_FEED_COMMENT_LIKE_START,
            commentUuid: conversationCommentUuid
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        const response = yield call(
            gcApi.post,
            `/conversation-service/conversation/comment/like/${conversationCommentUuid}`
        );

        pushNewsFeedAnalytics('Post Details', 'Like a comment');

        yield put({
            type: ADD_NEWS_FEED_COMMENT_LIKE_SUCCESS,
            commentUuid: conversationCommentUuid
        });

        const { fullName, displayName } = response.data;
        // update to news feed comment reducer
        yield put({
            type: UPDATE_NEWS_FEED_COMMENT_LIKED_BY_USER,
            payload: { activityId, conversationCommentUuid, likedByUser: true, fullName, displayName }
        });
    } catch (e) {
        const errorReachLimit = e.response && e.response.status === 429;

        if (errorReachLimit) {
            yield put(setSocialLimitErrorDialog({ open: true, errorType: 'like' }));
        }

        const { conversationCommentUuid } = action.payload;
        yield put({
            type: ADD_NEWS_FEED_COMMENT_LIKE_FAIL,
            commentUuid: conversationCommentUuid,
            errorReachLimit
        });

        if (!errorReachLimit) {
            // set news feed error state
            yield put({
                type: UPDATE_NEWS_FEED_ERROR_STATE,
                hasError: true
            });
        }
    }
}

export function* removeNewsFeedCommentLike(action) {
    try {
        const { conversationCommentUuid, activityId, fullName, displayName } = action.payload;
        yield put({
            type: REMOVE_NEWS_FEED_COMMENT_LIKE_START,
            commentUuid: conversationCommentUuid
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        yield call(gcApi.delete, `/conversation-service/conversation/comment/like/${conversationCommentUuid}/0`);

        pushNewsFeedAnalytics('Post Details', 'Unlike a comment');

        yield put({
            type: REMOVE_NEWS_FEED_COMMENT_LIKE_SUCCESS,
            commentUuid: conversationCommentUuid
        });

        // update to news feed comment reducer
        yield put({
            type: UPDATE_NEWS_FEED_COMMENT_LIKED_BY_USER,
            payload: { activityId, conversationCommentUuid, likedByUser: false, fullName, displayName }
        });
    } catch (e) {
        const { conversationCommentUuid } = action.payload;
        yield put({
            type: REMOVE_NEWS_FEED_COMMENT_LIKE_FAIL,
            commentUuid: conversationCommentUuid
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* addNewsFeedConversationLike(action) {
    const { activityId, likerInfo } = action.payload;
    const conversationLikeUpdating = yield select((state) => state.newsFeedActivities.conversationLikeUpdating);
    const updating = conversationLikeUpdating[activityId];
    if (updating) return;

    try {
        yield put({
            type: ADD_NEWS_FEED_CONVERSATION_LIKE_START,
            activityId
        });

        yield put(resetNewsfeedErrorState());

        const response = yield call(gcApi.post, `/conversation-service/conversation/like/ACTIVITY/${activityId}`);

        /**
         * @type {import('utils/conversation/conversation').ConversationLikeDTO}
         */
        const conversationLikeDto = response.data;

        pushNewsFeedAnalytics('Post Details', 'Like a post');

        yield put({
            type: ADD_NEWS_FEED_CONVERSATION_LIKE_SUCCESS,
            activityId,
            likerInfo,
            conversationLikeDto
        });
    } catch (e) {
        const errorReachLimit = e.response && e.response.status === 429;

        if (errorReachLimit) {
            yield put(setSocialLimitErrorDialog({ open: true, errorType: 'like' }));
        }

        yield put({
            type: ADD_NEWS_FEED_CONVERSATION_LIKE_FAIL,
            activityId
        });

        if (!errorReachLimit) {
            yield put(setNewsfeedErrorState());
        }
    }
}

export function* removeNewsFeedConversationLike(action) {
    const { activityId, conversationUuid, likerInfo } = action.payload;
    const conversationLikeUpdating = yield select((state) => state.newsFeedActivities.conversationLikeUpdating);
    const updating = conversationLikeUpdating[activityId];
    if (updating) return;

    try {
        yield put({
            type: REMOVE_NEWS_FEED_CONVERSATION_LIKE_START,
            activityId
        });

        yield put(resetNewsfeedErrorState());

        yield call(gcApi.delete, `/conversation-service/conversation/like/${conversationUuid}/0`);

        pushNewsFeedAnalytics('Post Details', 'Unlike a post');

        yield put({
            type: REMOVE_NEWS_FEED_CONVERSATION_LIKE_SUCCESS,
            activityId,
            likerInfo
        });
    } catch (e) {
        yield put({
            type: REMOVE_NEWS_FEED_CONVERSATION_LIKE_FAIL,
            activityId
        });

        yield put(setNewsfeedErrorState());
    }
}

export function* fetchNewsFeedCommentLikers(action) {
    const { conversationCommentUuid, activityId } = action.payload;
    try {
        const response = yield call(
            gcApi.get,
            `/conversation-service/conversation/comment/likes/v2/${conversationCommentUuid}?start=1&limit=10&connectionStatusIncluded=true`
        );

        const { commentLikeList, numberOfLikes } = response.data;

        yield put({
            type: FETCH_NEWS_FEED_COMMENT_LIKERS_SUCCESS,
            activityId,
            commentUuid: conversationCommentUuid,
            likers: commentLikeList.map((liker) => ({
                fullName: liker.fullName,
                displayName: liker.displayName
            })),
            numberOfLikes: numberOfLikes
        });
    } catch (e) {
        yield put({
            type: FETCH_NEWS_FEED_COMMENT_LIKERS_FAIL
        });
    }
}

export function* fetchNewsFeedConversationLikes(action) {
    const { resourceId, start, limit, connectionStatusIncluded } = action.payload;
    try {
        yield put({
            type: FETCH_NEWS_FEED_CONVERSATION_LIKES_START,
            reset: start === 1
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        const response = yield call(
            gcApi.get,
            `/conversation-service/conversation/likes/ACTIVITY/${resourceId}?start=${start}&limit=${limit}&connectionStatusIncluded=${connectionStatusIncluded}`
        );

        yield put({
            type: FETCH_NEWS_FEED_CONVERSATION_LIKES_SUCCESS,
            data: response.data || []
        });

        yield fork(fetchLikerProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_NEWS_FEED_CONVERSATION_LIKES_FAIL
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* fetchNewsFeedActivities(action) {
    const nextCursor = yield select((state) => state.newsFeedActivities.nextCursor);
    const activitiesFetching = yield select((state) => state.newsFeedActivities.activitiesFetching);
    if (activitiesFetching) return;

    try {
        yield put({
            type: FETCH_NEWS_FEED_ACTIVITIES_START
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        const { reset, peopleFilter, activityTypeIdList } = action.payload;

        const queryStringPayload = {
            limit: 10
        };

        let url = '/web-gateway/newsfeed/v2';
        // cursor
        if (!reset && nextCursor) {
            queryStringPayload.cursor = nextCursor;
        }
        queryStringPayload.ownerType = peopleFilter || 'ALL';
        // parentActivityTypeId, for filter of Activity Types
        if (Array.isArray(activityTypeIdList)) {
            queryStringPayload.parentActivityTypeId = activityTypeIdList;
        }

        const featureOn = yield call(forceCheckHasUserProfileFrameFeature);

        if (featureOn) {
            queryStringPayload['image-version'] = Object.values(PROFILE_IMAGE_VERSION);
        }

        url += toQueryString(queryStringPayload);

        const response = yield call(gcApi.get, url);

        // extract highlighted comments
        yield put({
            type: ADD_NEWS_FEED_HIGHLIGHTED_COMMENTS,
            data: response.data
        });

        yield put({
            type: FETCH_NEWS_FEED_ACTIVITIES_SUCCESS,
            data: response.data || []
        });

        yield fork(fetchNewsFeedActivitiesProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_NEWS_FEED_ACTIVITIES_FAIL
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* updateNewsfeedActivityPrivacy(action) {
    const { accessControlRuleDTO, activityId } = action.payload;

    yield put({
        type: UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_START,
        activityId // it's for indicating which activity is updating privacy
    });

    // reset news feed error state
    yield put({
        type: UPDATE_NEWS_FEED_ERROR_STATE,
        hasError: false
    });

    try {
        yield call(gcApi.put, `/activity-service/activity/${activityId}`, action.payload);

        yield put({
            type: UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_SUCCESS,
            accessControlRuleDTO,
            activityId
        });
    } catch (e) {
        yield put({
            type: UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_FAIL
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* fetchNewsfeedActivityAndUpdateLikes({ activityId }) {
    try {
        resetNewsfeedErrorState();
        const response = yield call(gcApi.get, `/web-gateway/newsfeed/${activityId}`);
        yield put({
            type: UPDATE_NEWS_FEED_ACTIVITY_LIKES,
            data: response.data
        });
    } catch (error) {
        setNewsfeedErrorState();
    }
}

export function* removeConnection(action) {
    const { displayName } = action.payload;
    try {
        yield put({
            type: REMOVE_CONNECTION_START
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        // the first call to get connectionRequestId
        const response = yield call(gcApi.get, `/userprofile-service/connection/profileStatus/${displayName}`);
        const { connectionRequestId } = response.data;
        // the second call to execute removing connection
        yield call(gcApi.delete, `/userprofile-service/connection/connectionRequest/${connectionRequestId}`);

        yield put({
            type: FILTER_NEWS_FEED_ACTIVITIES,
            displayName
        });

        yield put({
            type: REMOVE_CONNECTION_SUCCESS
        });
    } catch (e) {
        yield put({
            type: REMOVE_CONNECTION_FAIL
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* muteConnection(action) {
    const { displayName } = action.payload;
    try {
        yield put({
            type: MUTE_CONNECTION_START
        });

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        // the second call to execute removing connection
        yield call(gcApi.post, `/connection-service/muteuser/${displayName}`);

        yield put({
            type: FILTER_NEWS_FEED_ACTIVITIES,
            displayName
        });

        yield put({
            type: MUTE_CONNECTION_SUCCESS
        });
    } catch (e) {
        yield put({
            type: MUTE_CONNECTION_FAIL
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* unmuteConnection(action) {
    const { displayName } = action.payload;
    try {
        yield put({
            type: UNMUTE_CONNECTION_START
        });

        yield call(gcApi.delete, `/connection-service/muteuser/${displayName}`);

        yield put({
            type: UNMUTE_CONNECTION_SUCCESS
        });
    } catch (e) {
        yield put({
            type: UNMUTE_CONNECTION_FAIL
        });
    }
}

export function* fetchMutedConnectionList() {
    try {
        yield put({
            type: FETCH_MUTED_CONNECTION_LIST_START
        });

        const response = yield call(gcApi.get, '/connection-service/muteuser');

        yield put({
            type: FETCH_MUTED_CONNECTION_LIST_SUCCESS,
            mutedConnectionList: response.data.mutedUserList
        });

        yield fork(fetchMutedConnectionListProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_MUTED_CONNECTION_LIST_FAIL
        });
    }
}

export function* fetchConnectionCount() {
    try {
        const response = yield call(gcApi.get, '/connection-service/connection/connections/count');

        // reset news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: false
        });

        yield put({
            type: FETCH_CONNECTION_COUNT_SUCCESS,
            connectionCount: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_CONNECTION_COUNT_FAIL
        });

        // set news feed error state
        yield put({
            type: UPDATE_NEWS_FEED_ERROR_STATE,
            hasError: true
        });
    }
}

export function* fetchSuggestedConnectionList(action) {
    try {
        yield put({
            type: FETCH_SUGGESTED_CONNECTION_LIST_START
        });

        let url = '/usersearch-service/connection/suggestions';

        const response = yield call(gcApi.post, url, action.payload);

        yield put({
            type: FETCH_SUGGESTED_CONNECTION_LIST_SUCCESS,
            data: response.data || []
        });
        yield fork(fetchSuggestedConnectionListProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_SUGGESTED_CONNECTION_LIST_FAIL
        });
    }
}

export function* fetchPagedSuggestedConnectionList(action) {
    try {
        yield put({
            type: FETCH_PAGED_SUGGESTED_CONNECTION_LIST_START
        });

        let url = '/usersearch-service/connection/suggestions/pagination';

        const response = yield call(gcApi.post, url, action.payload);

        yield put({
            type: FETCH_PAGED_SUGGESTED_CONNECTION_LIST_SUCCESS,
            data: response.data || []
        });
        yield fork(fetchSuggestedConnectionListProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_PAGED_SUGGESTED_CONNECTION_LIST_FAIL
        });
    }
}

export function* fetchSuggestedConnectionsCount(action) {
    try {
        let url = '/usersearch-service/connection/suggestions';

        const response = yield call(gcApi.post, url, action.payload);

        yield put({
            type: FETCH_SUGGESTED_CONNECTIONS_COUNT_SUCCESS,
            count: response.data.profileList.length || 0
        });

        yield fork(fetchSuggestedConnectionListProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_SUGGESTED_CONNECTIONS_COUNT_FAIL
        });
    }
}

const REMOVE_IMAGE_STATUS = [`FLAGGED_FOR_REVIEW_BY_HUMAN`, `FLAGGED_FOR_SECOND_REVIEW_BY_HUMAN`];

export function* submitReportPhotoSaga(action) {
    const { flagReason, note } = action;
    const reportDialogState = yield select(getReportDialogState);
    const { activityId, imageUuid } = reportDialogState;
    try {
        const response = yield call(gcApi.post, `/activity-service/activity/${activityId}/image/${imageUuid}/flag`, {
            flagReason,
            referrerContext: 'GCWeb Activity',
            note
        });

        yield put(submitReportPhotoDone({ reviewStatus: response.data.reviewStatus }));
        /** only remove image under these status */
        if (REMOVE_IMAGE_STATUS.includes(response.data.reviewStatus)) {
            /** close photo modal */
            yield put(hideModal());
            yield put(removePhotoFromFeed({ activityId, imageUuid }));
        }
    } catch (error) {
        if (error.response && error.response.status === 429) {
            yield put(submitReportPhotoDone({ reviewStatus: 'REPORTED' }));
        } else {
            yield put(submitReportPhotoDone({ error: true, reviewStatus: null }));
        }
    }
}

/// section: fetching profile image and frame

/**
 * handle fetch likers response. (use in opening liker dialog)
 * @param {Object[]} responseData
 * @param {number} responseData[].userProfilePk
 */
function* fetchLikerProfileImageAndFrameSaga(responseData) {
    const userIds = (responseData || []).map((item) => item.userProfilePk);
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

/**
 * handle web-gateway response. profile images and frames are include in `responseData.profileInfos`
 * @param {Object} responseData
 * @param {Object} responseData.profileInfos
 * @returns
 */
function* fetchNewsFeedActivitiesProfileImageAndFrameSaga(responseData) {
    if (!responseData?.profileInfos) {
        return;
    }
    yield put(fetchMultipleUserSocialProfileImageDone({ data: responseData?.profileInfos }));
}

/**
 * handle comments profile images and frames
 * @param {Object[]} responseData
 * @param {number} responseData[].userProfilePk
 */
function* fetchCommentsProfileImageAndFrameSaga(responseData) {
    if (!responseData?.length) {
        return;
    }
    const userIds = responseData.map((item) => item.userProfilePk);
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

/**
 * handle suggested connection list
 * @param {Object} responseData
 * @param {Object[]} responseData.profileList
 * @param {number} responseData.profileList[].userId
 */
function* fetchSuggestedConnectionListProfileImageAndFrameSaga(responseData) {
    if (!responseData?.profileList?.length) {
        return;
    }
    const userIds = responseData?.profileList.map((item) => item.userId);
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

/**
 * handle muted connection list
 * @param {Object} responseData
 * @param {Object[]} responseData.mutedUserList
 * @param {number} responseData.mutedUserList[].userProfileId
 * @returns
 */
function* fetchMutedConnectionListProfileImageAndFrameSaga(responseData) {
    if (!responseData?.mutedUserList?.length) {
        return;
    }
    const userIds = responseData?.mutedUserList.map((item) => item.userProfileId);
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

function* fetchProfileImageAndFrameSaga(userIds) {
    if (!userIds || !userIds.length) {
        return;
    }
    yield put(fetchMultipleUserSocialProfileImage(userIds));
}

/// end section: fetching profile image and frame

export const newsFeedSagas = [
    // activities
    takeLatest(FETCH_NEWS_FEED_ACTIVITIES, fetchNewsFeedActivities),
    takeEvery(UPDATE_NEWS_FEED_ACTIVITY_PRIVACY, updateNewsfeedActivityPrivacy),
    takeEvery(FETCH_NEWS_FEED_ACTIVITY_AND_UPDATE_LIKES, fetchNewsfeedActivityAndUpdateLikes),
    // comments
    takeEvery(FETCH_NEWS_FEED_COMMENTS, fetchNewsFeedComments),
    takeEvery(ADD_NEWS_FEED_COMMENT, addNewsFeedComment),
    takeEvery(EDIT_NEWS_FEED_COMMENT, editNewsFeedComment),
    takeEvery(REMOVE_NEWS_FEED_COMMENT, removeNewsFeedComment),
    takeEvery(FETCH_NEWS_FEED_COMMENT_LIKERS, fetchNewsFeedCommentLikers),
    // likes
    takeLatest(FETCH_NEWS_FEED_CONVERSATION_LIKES, fetchNewsFeedConversationLikes),
    takeEvery(FETCH_NEWS_FEED_COMMENT_LIKES, fetchNewsFeedCommentLikes),
    takeEvery(ADD_NEWS_FEED_COMMENT_LIKE, addNewsFeedCommentLike),
    takeEvery(REMOVE_NEWS_FEED_COMMENT_LIKE, removeNewsFeedCommentLike),
    takeEvery(ADD_NEWS_FEED_CONVERSATION_LIKE, addNewsFeedConversationLike),
    takeEvery(REMOVE_NEWS_FEED_CONVERSATION_LIKE, removeNewsFeedConversationLike),
    // connections
    takeEvery(REMOVE_CONNECTION, removeConnection),
    takeEvery(MUTE_CONNECTION, muteConnection),
    takeEvery(UNMUTE_CONNECTION, unmuteConnection),
    takeEvery(FETCH_MUTED_CONNECTION_LIST, fetchMutedConnectionList),
    takeEvery(FETCH_CONNECTION_COUNT, fetchConnectionCount),
    takeEvery(FETCH_SUGGESTED_CONNECTION_LIST, fetchSuggestedConnectionList),
    takeEvery(FETCH_PAGED_SUGGESTED_CONNECTION_LIST, fetchPagedSuggestedConnectionList),
    takeEvery(FETCH_SUGGESTED_CONNECTIONS_COUNT, fetchSuggestedConnectionsCount),
    // reporter
    takeLatest(NEWS_FEED_SUMBIT_REPORT_PHOTO, submitReportPhotoSaga)
];
